import {
    MissingTranslationHandler,
    MissingTranslationHandlerParams,
} from "@ngx-translate/core";

export class ShowKeyHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        return params.key;
    }
}
